<script setup lang="ts">
import { useClock, useStopwatch, useFormat } from '#imports'

export interface UIClockCounterProps {
    type?: 'counter' | 'clock'
    withIcon?: boolean
}

const props = withDefaults(
    defineProps<UIClockCounterProps>(),
    {
        type: 'clock',
        withIcon: true
    }
)

const { clock } = useClock()
const { counter, startCounter } = useStopwatch()
const { asTime } = useFormat()

if (props.type === 'counter') {
    startCounter()
}
</script>

<template>
    <span class="clock">
        <UIIcon
            v-if="withIcon"
            class="clock__icon"
            name="clock"
            size="10"
        />
        <span class="clock__time">{{
            type === 'counter' ? counter : asTime(clock, {
                format: "LT"
            })
        }}</span>
    </span>
</template>

<style lang="scss" scoped>
.clock {
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    gap: 4px;

    &__icon {
        @media (max-width: #{$screen-xs - 1}) {
            display: none;
        }
    }

    &__time {
        font-size: $font-size-xxs - 2;
        line-height: 1;

        @include mobile(sm) {
            font-size: $font-size-xxs;
        }
    }
}
</style>
